// extracted by mini-css-extract-plugin
export default {"low_comments_container":"chat_low_comments_container__-qgwQ","no_comments_container":"chat_no_comments_container__z5x4u","no_comments_text":"chat_no_comments_text__XnHKb"};